import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Check, FileText, Calendar, Utensils, Timer } from 'lucide-react';
export function ProductDetailsSection() {
  const features = [{
    icon: <Calendar className="w-6 h-6 text-brand-orange" data-id="element-216" />,
    title: 'The 4-Week Blueprint',
    desc: 'Exactly what to do on Monday, Wednesday, and Friday. No guesswork. Just follow the plan.'
  }, {
    icon: <FileText className="w-6 h-6 text-brand-orange" data-id="element-217" />,
    title: "The 'Swap-This-For-That' Matrix",
    desc: '20+ painful exercises replaced by their joint-safe cousins. Never hurt your knees again.'
  }, {
    icon: <Utensils className="w-6 h-6 text-brand-orange" data-id="element-218" />,
    title: 'The Anti-Inflammatory Menu',
    desc: 'Eat to lower CRP (C-Reactive Protein) and stop joint swelling at the source.'
  }, {
    icon: <Timer className="w-6 h-6 text-brand-orange" data-id="element-219" />,
    title: "The 'Micro-Dose' Cardio Guide",
    desc: '10-minute finishers that burn more than a 5k run without the impact.'
  }];
  return <Section background="darker" className="border-y border-slate-900" data-id="element-220">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-222">
          <h2 className="text-4xl font-heading font-bold text-white mb-8 uppercase" data-id="element-223">
            What's Inside The{' '}
            <span className="text-brand-orange" data-id="element-224">PDF System</span>
          </h2>

          <div className="space-y-8" data-id="element-225">
            {features.map((feature, i) => <div key={i} className="flex gap-5" data-id="element-226">
                <div className="w-12 h-12 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-227">
                  {feature.icon}
                </div>
                <div data-id="element-228">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-229">
                    {feature.title}
                  </h3>
                  <p className="text-slate-400" data-id="element-230">{feature.desc}</p>
                </div>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="relative" data-id="element-231">
          <div className="absolute inset-0 bg-brand-orange/20 blur-[100px] rounded-full opacity-30" data-id="element-232"></div>
          <div className="relative bg-slate-900 border border-slate-800 p-8 rounded-xl shadow-2xl" data-id="element-233">
            <h3 className="text-2xl font-heading font-bold text-white mb-6 uppercase text-center border-b border-slate-800 pb-4" data-id="element-234">
              Instant Digital Access
            </h3>
            <ul className="space-y-4" data-id="element-235">
              {['Full 4-Week Training Program (PDF)', 'Video Library Access for Form Checks', 'Mobile-Optimized for Gym Use', 'Printable Workout Logs', 'Lifetime Updates'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-300" data-id="element-236">
                  <Check className="w-5 h-5 text-green-500" data-id="element-237" />
                  <span data-id="element-238">{item}</span>
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-slate-800 text-center" data-id="element-239">
              <p className="text-slate-500 text-sm" data-id="element-240">
                Compatible with all devices: iOS, Android, Desktop
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}